<template>
  <transition name="efade" tag="div" mode="out-in">
    <div class="filters" v-if="currentFilters !== false">
      <h2 class="text-xl mb-3">Filters</h2>
      <div class="flex flex-col">
        <span @click="changeFilter(false)" :class="['link mb-2', !filter ? 'active' : '']">Show All</span>
        <span
          v-for="f in currentFilters"
          :key="`filter_${route}_${f}`"
          @click="changeFilter(f)"
          :class="['link mb-2', filter === f ? 'active' : '']"
          >{{ f }}</span
        >
      </div>
    </div>
    <div class="filters" v-if="currentSections && !loading">
      <h2 class="text-xl mb-3">Sections</h2>
      <div class="flex flex-col">
        <span
          v-for="(f, ind) in currentSections"
          :key="`section_${route}_${f.name}`"
          @click="$bus.$emit('section')"
          v-scroll-to="`#${f.tag}`"
          :class="['link mb-2', section.tag === f.tag ? 'active' : '']"
          >{{ f.name }}</span
        >
      </div>
    </div>
  </transition>
</template>

<script>
//v-scroll-to="'#team1'"
export default {
  name: 'Filters',

  data() {
    return {
      key: 'type_string',
      loading: true,
      filter: false,
      hasRecordingVideo: false,
      filters: {
        education: {
          filters: ['Degree', 'Webinar', 'Workshop', 'Conference', 'Online', 'In Person'],
          key: 'type_string',
        },
        design: {
          filters: ['For Sale', 'Not For Sale'],
          key: 'for_sale',
        },
        team: {
          filters: ['Leadership', 'Associate', 'Member'],
          key: 'position',
        },
      },
      section: false,
      sections: {
        'education-detail': [
          {
            name: 'Description',
            tag: 'edu-description',
          },
          {
            name: 'Details',
            tag: 'edu-details',
          },
          {
            name: 'Schedule',
            tag: 'edu-schedule',
          },
          {
            name: 'Team',
            tag: 'edu-team',
          },
          {
            name: 'Recording',
            tag: 'edu-recording',
          },
          {
            name: 'Results',
            tag: 'edu-results',
          },
        ],
        'design-detail': [
          {
            name: 'Description',
            tag: 'd-description',
          },
          {
            name: 'Details',
            tag: 'd-details',
          },
        ],
        'education-degree-masters-detail': [
          {
            name: 'Description',
            tag: 'edum-description',
          },
          {
            name: 'Details',
            tag: 'edum-details',
          },
          {
            name: 'Chapters',
            tag: 'edum-chapters',
          },
          {
            name: 'Labs',
            tag: 'edum-labs',
          },
          {
            name: 'Partners',
            tag: 'edum-partners',
          },
          {
            name: 'FAQs',
            tag: 'edum-faqs',
          },
          {
            name: 'Alumni',
            tag: 'edum-alumni',
          },
          {
            name: 'Results',
            tag: 'edum-results',
          },
        ],
        'education-degree-phd-detail': [
          {
            name: 'Description',
            tag: 'edum-description',
          },
          {
            name: 'Details',
            tag: 'edum-details',
          },
          {
            name: 'Pathways',
            tag: 'edum-chapters',
          },
          {
            name: 'Partners',
            tag: 'edum-partners',
          },
          {
            name: 'FAQs',
            tag: 'edum-faqs',
          },
        ],
      },
      page: false,
    };
  },

  created() {
    this.$bus.$on('loading', (loading) => {
      this.loading = loading;
    });

    this.$bus.$on('hasRecordingVideo', (hasRecordingVideo) => {
      this.hasRecordingVideo = hasRecordingVideo;
    });

    this.$bus.$on('scroll', () => {
      if (this.page === false) {
        this.page = document.getElementById('page');
      }

      for (let i = 0; i < this.currentSections.length; i++) {
        let s = this.currentSections[i];
        let el = $(`#${s.tag}`);
        let top = el.offset().top;

        if (top + el.height() * 0.9 >= 150) {
          this.section = s;
          break;
        }
      }

      if (this.page.scrollTop === this.page.scrollHeight - this.page.offsetHeight) {
        this.$bus.$emit('scroll-end', true);
      } else {
        this.$bus.$emit('scroll-end', false);
      }
    });

    this.$bus.$on('scrollDown', () => {
      if (this.currentSections !== false) {
        let i = this.currentSections.indexOf(this.section);

        let newSec = this.currentSections[i + 1];

        if (typeof newSec !== 'undefined') {
          this.$scrollTo(`#${newSec.tag}`);
          this.section = newSec;
        }
      }
    });
  },

  watch: {
    $route(to, from) {
      this.$store.state.educationResults = false;
      this.filter = false;
      this.section = false;
      this.page = false;

      if (this.$route.name === 'education-detail') {
        this.loading = true;
        this.$bus.$emit('loading', true);
      }

      if (typeof this.$route.meta.index === 'undefined') {
        this.$bus.$off('scrollDown');
        this.$bus.$on('scrollDown', () => {
          if (this.currentSections !== false) {
            let i = this.currentSections.indexOf(this.section);

            let newSec = this.currentSections[i + 1];

            if (typeof newSec !== 'undefined') {
              this.$scrollTo(`#${newSec.tag}`);
              this.section = newSec;
            }
          }
        });
      }
    },
  },

  computed: {
    route: function () {
      return this.$route.name;
    },
    currentFilters: function () {
      if (typeof this.filters[this.route] !== 'undefined' && 'filters' in this.filters[this.route]) {
        return this.filters[this.route].filters;
      }
      return false;
    },
    currentSections: function () {
      if (typeof this.sections[this.route] !== 'undefined') {
        this.section = this.sections[this.route][0];

        if (this.route === 'education-detail') {
          const sections = this.sections[this.route].filter((e) => {
            return e.name === 'Recording' ? this.hasRecordingVideo : true;
          });

          if (this.$store.state.educationResults !== true) {
            return sections.filter((e) => e.name !== 'Results');
          } else {
            return sections;
          }
        }

        return this.sections[this.route];
      }
      return false;
    },
  },

  methods: {
    changeFilter(filter) {
      if (filter === this.filter) {
        return;
      }

      this.filter = filter;
      this.$bus.$emit('filter', {
        route: this.route,
        key: this.filters[this.route].key,
        filter,
      });
    },
  },
};
</script>
